import Box from "@material-ui/core/Box";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BreadcrumbPage } from "../../shared";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from '@mui/material/Button';
import EllipsisText from "react-ellipsis-text";
import axios from "axios";
import { InputLabel, TextareaAutosize } from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { CommonCss } from "../../services/CommonCss";
import { DatePicker, KeyboardDatePicker } from "@material-ui/pickers";
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useDispatch } from "react-redux";
import { LOADING } from "../../action";
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import CancelIcon from '@mui/icons-material/Cancel';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { cookieKeys, getCookie } from "../../services/Cookies";
import { setYear } from "date-fns";
const top100Films = [
    { title: 'The Shawshank Redemption', year: 1994 },
    { title: 'The Godfather', year: 1972 },
    { title: 'The Godfather: Part II', year: 1974 },
    { title: 'The Dark Knight', year: 2008 },
    { title: '12 Angry Men', year: 1957 },
    { title: "Schindler's List", year: 1993 },
    { title: 'Pulp Fiction', year: 1994 },
    {
        title: 'The Lord of the Rings: The Return of the King',
        year: 2003,
    },
    { title: 'The Good, the Bad and the Ugly', year: 1966 },
    { title: 'Fight Club', year: 1999 },
    {
        title: 'The Lord of the Rings: The Fellowship of the Ring',
        year: 2001,
    },
    {
        title: 'Star Wars: Episode V - The Empire Strikes Back',
        year: 1980,
    },

];


const useStyles = makeStyles((theme) => ({
    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        fontSize: '14px; font-weight: normal',
        padding: '4px 10px',
        width: '115px !important'

    },
    FU_btn: {
        border: '1px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        fontSize: '14px; font-weight: normal',
        padding: '4px 10px',
        width: '350px !important'

    },
    btn2: {

        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '14px; font-weight: normal',
        padding: '4px 10px',
        width: '115px !important'
    },
    textstyles: {
        color: '#ff4717'
    },

    boxLayout: {
        backgroundColor: "#fff",
        boxShadow: "0px 0px 2px 1px rgb(0 0 0 / 12%)",
        borderRadius: 8,
    },
    txtInput: {
        "& input": {
            padding: "8px 8px",
            fontWeight: 600,
        },
        "& fieldset": {
            borderRadius: 0,
        },
    },
    breadcrumbBox: {
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
    },
    btnStyle1: {
        borderRadius: "8px",
        border: "2px solid #ff4717",
        boxShadow: "2px 2px 4px 2px #dadada",
        color: "#ff4717",
        background: "#fff !important",
        textTransform: "capitalize",
        padding: "4px 22px",
    },
    btnStyle2: {
        borderRadius: "8px",
        border: "2px solid #ff4717",
        boxShadow: "2px 2px 4px 2px #dadada",
        color: "#ffffff",
        background: "#ff4717 !important",
        textTransform: "capitalize",
        padding: "4px 22px",
        marginRight: "8px"
    },
    btnStyle3: {
        borderRadius: "12px",
        border: "2px solid #ff4717",
        boxShadow: "2px 2px 4px 2px #dadada",
        color: "#ffffff",
        background: "#ff4717 !important",
        textTransform: "capitalize",
        padding: "2px 11px",
        alignItems: "right"
    },
    radioInput: {
        padding: 0,
        "& span.Mui-checked": {
            color: "#1a1a31",
        },
    },
    mainSelectDropdown: {
        border: "1px solid #000",
        padding: "8px 10px 8px !important",
        float: "left",
    },
    selectDropdown: {
        height: "100px",
        overflowY: "auto",
    },
    iconSelect: {
        position: "absolute",
        right: "-8px",
    },
    dropdownActive: {
        display: "block",
    },
    dropdownInactive: {
        display: "none",
    },
    formControl: {
        width: "100%",
    },
    selectDropdownActive: {
        color: "#ff4717",
    },
    seletedItem: {
        padding: "4px 8px",
        backgroundColor: "#ff47174a",
        marginRight: "4px",
        borderRadius: "16px",
        float: "left",
        marginBottom: "4px",
        fontSize: "11px",
    },
    autoTextbox: {
        border: "0px"
    },
    searchTxt: {
        "& .MuiFormControl-root": {
            margin: "0px !important",
            borderTop: "1px solid #000 !important",
            borderLeft: "1px solid #000 !important",
            borderRight: "1px solid #000 !important"
        },
        "& .MuiInputBase-root": {
            outline: "0px solid #000 !important",
            margin: "0px !important"
        },
        "& .MuiInputBase-root fieldset": {
            border: "0px solid #000 !important"
        }
    },
    readonlyTxt: {
        "& input": {
            backgroundColor: "#eee",
            padding: "8px 8px"
        }
    }
}));
export default function BunkerAlertForm(props) {
    const [BreadcrumbList, setBreadcrumbList] = useState(
        [
            { name: props.match.params.id ? "Edit Bunker Alert" : "Add BunkerAlert", url: "" },
        ]);
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();


    let formparameters = {
        year: "",
        bano: "",
        date: new Date(),
        subject: "",
        testParameter: "",
        bargeName: "",
        fuelGrade: "",
        portName: "",
        countryNm: "",
        region: "",
        mainport: "",
        supplier: "",
        file: "",
        geographicalregionds: "",
    }
    const [formvalues, setFormvalues] = useState(formparameters);
    const imageInputRef = React.useRef();
    const [ID, setId] = useState("");
    const [profilePic, setProfilePic] = useState(null);
    const [selectedYear, setselectedYear] = React.useState(new Date());
    const [product, setProduct] = React.useState([]);
    const [port, setPort] = React.useState([]);
    const [mainport, setMainPort] = React.useState([]);
    const [BargeName, setBargeName] = React.useState([]);
    const [selectedvalue, setSelectedValue] = React.useState([]);
    const [TestParameter, setTestParameter] = React.useState([]);
    const [region, setRegion] = React.useState([]);
    const [Country, setCountry] = React.useState([]);
    const [Supplier, setSupplier] = React.useState([]);
    const [filepath, setfilepath] = useState("");
    const [fName, setFName] = useState("");
    const [pdfURL, setPdfURL] = useState("");
    const [openpdf, setOpenpdf] = React.useState(false);
    const [filteredString, setValue] = useState("");
    //const [selectedDate, handleDateChange] = useState(new Date());
    const getBunkerAlertDataID = (ID) => {
        //;
        debugger
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/GetBunkerAlertDataID/${ID}`;
        dispatch({ type: LOADING, payload: true });
        getRequest(url)
            .then((res) => {
                if (res.status == 200) {
                    dispatch({ type: LOADING, payload: false });
                    setFName(res.data[0].filepath);
                    setselectedYear({ year: res.data[0].year })
                    setfilepath(res.data[0].filepath);
                    let dataobject = res.data[0].date.split('T')
                    let newdateformet = new Date(dataobject[0]);

                    // let countryarr=[];
                    // countryarr.push(res.data[0].country);
                    // let methodcountry=countryarr.map((ele, idx) => {
                    //   return { "countryNm": ele }
                    // }) 
                    // console.log("methodcountry",methodcountry)

                    // let portarr=[];
                    // portarr.push(res.data[0].port);
                    // let methodport=portarr.map((ele, idx) => {
                    //   return { "portName": ele }
                    // }) 
                    // console.log("methodport",methodport)

                    let testpara = res.data[0].testParameter.split(',')
                    console.log(testpara);
                    let methodtestpara = testpara.map((ele, idx) => {
                        return { "testParameter": ele }
                    })

                    let bar = res.data[0].bargeName.split(',')
                    let methodbar = bar.map((ele, idx) => {
                        return { "bargeName": ele }
                    })

                    let pro = res.data[0].fuelGrade.split(',');
                    let methodproduct = pro.map((ele, idx) => {
                        return { "fuelGrade": ele }
                    })

                    let sup = res.data[0].supplier.split(',');
                    let methodsupplier = sup.map((ele, idx) => {
                        return { "supplier": ele }
                    })
                    setFormvalues({
                        ...formvalues,
                        supplier: methodsupplier,
                        fuelGrade: methodproduct,
                        bargeName: methodbar,
                        testParameter: methodtestpara,
                        year: res.data[0].year,
                        bano: res.data[0].bA_No,
                        date: newdateformet,
                        subject: res.data[0].subject,
                        countryNm: res.data[0].country,
                        portName: res.data[0].port,
                        geographicalregionds: res.data[0].region,
                        mainport: res.data[0].mainport,

                    })

                } else {
                    dispatch({ type: LOADING, payload: false });
                    ToastError(res.data.message);
                }
            })
            .catch((error) => {
                ToastError(error.response.data.message);
                dispatch({ type: LOADING, payload: false });
            });
    }
    useEffect(() => {
        ////debugger
        let ID = props.match.params.id;
        if (ID !== "" && ID !== undefined) {
            getBunkerAlertDataID(ID);
        }
        setId(props.match.params.id)
        let year = new Date();
        let selectednewYear = year.getFullYear();
        setFormvalues({ ...formvalues, year: selectednewYear });
    }, []);
    const handleClose = () => {

        //setOpenAlert(false);
        setOpenpdf(false)
    };
    const loadPdfFile = (data) => {
        ////
        dispatch({ type: LOADING, payload: true });
        const token = getCookie("token");

        const url =
            process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/downloadFile`;
        let filedata = JSON.stringify({ "fileName": data });
        let config = {
            method: "post",
            responseType: "blob",
            url: url,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                Accept: "application/pdf"
            },
            data: filedata,
        };
        axios(config)
            .then(async function (response) {
                ////;
                if (response.status == 200) {
                    ////;
                    dispatch({ type: LOADING, payload: false });
                    const file = new Blob([response.data], { type: "application/pdf" });
                    //Build a URL from the file
                    const fileURL = URL.createObjectURL(file);
                    // var link = document.createElement('a');
                    // link.href = fileURL;
                    setPdfURL(fileURL);
                    setOpenpdf(true)
                    //link.click();
                    //window.open(fileURL,'_blank');
                    //setOpenBunkerAlerts(fileURL);
                } else {
                    ToastError(response.data.message);
                }
            })
            .catch(function (error) {
                ////;
                dispatch({ type: LOADING, payload: false });
                ////console.log(error);
            });
    };
    const handleDateChange = (event) => {

        let year = new Date(event)
        let selectednewYear = year.getFullYear();
        setFormvalues({ ...formvalues, year: selectednewYear });
        setselectedYear(event);
    }
    const updateform = async () => {
        //
        if (formvalues.year !== "" && formvalues.bano !== "" && formvalues.date !== "" && formvalues.subject !== "" && formvalues.geographicalregionds !== "" && formvalues.countryNm !== "" && formvalues.portName !== "" && formvalues.mainport !== "" && formvalues.testParameter !== "" && formvalues.fuelGrade !== "" && formvalues.bargeName !== "" && formvalues.supplier !== "") {
            let Data = formvalues;
            const formData = new FormData();

            let dd = String(Data.date.getDate()).padStart(2, '0');
            let mm = String(Data.date.getMonth() + 1).padStart(2, '0');
            let yyyy = Data.date.getFullYear();

            let Date = mm + '-' + dd + '-' + yyyy;

            Data.testParameter?.map((val, idx) => {
                formData.append("testparameter[]", JSON.stringify(val.testParameter));

            });
            Data.fuelGrade?.map((val, idx) => {
                formData.append("product[]", JSON.stringify(val.fuelGrade));

            });
            Data.bargeName?.map((val, idx) => {
                formData.append("bargename[]", JSON.stringify(val.bargeName));

            });
            Data.supplier?.map((val, idx) => {
                formData.append("supplier[]", JSON.stringify(val.supplier));
                //supplier.push(val.supplier)
            });


            formData.append("year", Data.year);
            formData.append("bano", Data.bano);
            formData.append("date", Date);
            formData.append("subject", Data.subject);
            formData.append("region", Data.geographicalregionds);
            formData.append("country", Data.countryNm);
            formData.append("port", Data.portName);
            formData.append("mainport", Data.mainport);
            if (formvalues.file) {
                formData.append("file", profilePic);
            }

            const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/BunkerAlertSubmit/${ID}`;
            dispatch({ type: LOADING, payload: true });
            await putRequest(url, formData)
                .then((res) => {
                    dispatch({ type: LOADING, payload: false });
                    if (res.status == 200) {
                        ToastSuccess("Updated successfully");
                        history.push("/dashboard/bunker-alert");
                    } else {
                        ToastSuccess("Unsucessfull");
                    }

                })
                .catch((error) => {
                    dispatch({ type: LOADING, payload: false });
                    ////console.log(error);

                });
        } else {
            ToastSuccess("Fill all Fields");
        }
    }
    const checkform = async () => {
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/GetBunkerAlertData`;
        dispatch({ type: LOADING, payload: true });
        getRequest(url)
            .then((res) => {
                if (res.status == 200) {
                    dispatch({ type: LOADING, payload: false });
                    let presentBAval = [];
                    let yearOnly = [];
                    let isExists;
                    isExists = res.data.find(o => o.year == formvalues.year && o.bA_No == formvalues.bano);
                    if (isExists) {
                        ToastError("Entered BA No is Already Exist");
                    }
                    else {
                        submitform();
                    }
                    /*
                    res.data.forEach((d) => {
                      console.log("res", res);
                      presentBAval.push(d. bA_No);
                      yearOnly.push(d.year);
                      //console.log("presentBAVal",presentBAval);
                    })
                   
                   if( yearOnly.includes(formvalues.year) && presentBAval.includes(formvalues.bano)){
                     
                      ToastError("Entered BA No is Already Exist");
                   }
                   else{
                      
                   }*/
                }
            })

    }

    const submitform = async () => {
        //
        if (formvalues.year !== "" && formvalues.bano !== "" && formvalues.date !== "" && formvalues.subject !== "" && formvalues.geographicalregionds !== "" && formvalues.countryNm !== "" && formvalues.portName !== "" && formvalues.mainport !== "" && formvalues.testParameter !== "" && formvalues.fuelGrade !== "" && formvalues.bargeName !== "" && formvalues.supplier !== "" && formvalues.file !== "") {
            let Data = formvalues;
            const formData = new FormData();


            let dd = String(Data.date.getDate()).padStart(2, '0');
            let mm = String(Data.date.getMonth() + 1).padStart(2, '0');
            let yyyy = Data.date.getFullYear();

            let Date = mm + '-' + dd + '-' + yyyy;

            Data.testParameter?.map((val, idx) => {
                formData.append("testparameter[]", JSON.stringify(val.testParameter));

            });
            Data.fuelGrade?.map((val, idx) => {
                formData.append("product[]", JSON.stringify(val.fuelGrade));

            });
            Data.bargeName?.map((val, idx) => {
                formData.append("bargename[]", JSON.stringify(val.bargeName));

            });
            Data.supplier?.map((val, idx) => {
                formData.append("supplier[]", JSON.stringify(val.supplier));

            });


            formData.append("year", Data.year);
            formData.append("bano", Data.bano);
            formData.append("date", Date);
            formData.append("subject", Data.subject);
            formData.append("country", Data.countryNm);
            formData.append("port", Data.portName);
            formData.append("region", Data.geographicalregionds);
            formData.append("mainport", Data.mainport);
            if (formvalues.file) {
                formData.append("file", profilePic);
            }

            const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/BunkerAlertSubmit`;
            dispatch({ type: LOADING, payload: true });
            await postRequest(url, formData)
                .then((res) => {
                    dispatch({ type: LOADING, payload: false });
                    if (res.status == 200) {
                        ToastSuccess("Inserted successfully");
                        history.push("/dashboard/bunker-alert");
                    } else {
                        ToastSuccess("Unsucessfull");
                    }

                })
                .catch((error) => {
                    dispatch({ type: LOADING, payload: false });
                    ////console.log(error);

                });
        } else {
            ToastSuccess("Fill all Fields");
        }


    }


    const handleChange = (event, value, field) => {
        debugger
        //;
        // if (field === 'Region') {
        //     if (value !== null) {
        //         setFormvalues({ ...formvalues, region: value.region, countryNm: '', portName: '', mainport: '' })
        //         localStorage.setItem("Region", value.region);
        //     }
        //     else {
        //         setFormvalues({ ...formvalues, region: '', countryNm: '', portName: '', mainport: '' })
        //         localStorage.setItem("Region", '');
        //     }
        //     //setFormvalues({ ...formvalues, countryNm: '' })
        //     //setFormvalues({ ...formvalues, portName: '' })
        //    // getCountry();
        // } else if (field === 'country') {
        if (field === 'country') {
            if (value !== null) {
                setFormvalues({ ...formvalues, countryNm: value.countryNm })
                localStorage.setItem("Country", value.countryNm);
            }
            else {
                setFormvalues({ ...formvalues, countryNm: '', })
                localStorage.setItem("Country", '');
            }
            //getPort();
            //getRegion();
        }
        else if (field === 'Region') {
            if (value !== null) {
                setFormvalues({ ...formvalues, geographicalregionds: value.geographicalregionds })
                localStorage.setItem("Region", value.geographicalregionds);
            }
            else {
                setFormvalues({ ...formvalues, geographicalregionds: '' })
                localStorage.setItem("Region", '');
            }
            //setFormvalues({ ...formvalues, countryNm: '' })
            //setFormvalues({ ...formvalues, portName: '' })
            // getCountry();
        }
        else if (field === 'port') {
            if (value !== null) {
                setFormvalues({ ...formvalues, portName: value.portName, mainport: '',geographicalregionds: '',countryNm: '', })
                localStorage.setItem("Port", value.portName);
            }
            else {
                setFormvalues({ ...formvalues, portName: '', mainport: '',geographicalregionds: '',countryNm: '', })
                localStorage.setItem("Port", '');
                //setPort('');
                setMainPort([]);
                setCountry([]);
                setRegion([]);
            }
            getCountry();
            getRegion();
            getmainport();
        }
        else if (field === 'supplier') {
            if (value.length > 0 ) {
                let supplierfilter = value.map((item) => item.supplier)
                setFormvalues({ ...formvalues, supplier: value, bargeName: '' })
                localStorage.setItem("Supplier", supplierfilter);

            }
            else {
                setFormvalues({ ...formvalues, supplier: '', bargeName: '' })
                localStorage.setItem("Supplier", '');
                setBargeName([]);
            }
            getBargename()
        }
    }

    const onSubmitProfile = (event) => {
        ////console.log(event.target.files[0],"img");

        var file = event.target.files[0];
        setProfilePic(file);
        setFormvalues({ ...formvalues, file: file });
    }
    const clearform = () => {
        // setFormvalues(formparameters)
        history.push("/dashboard/bunker-alert");
    }
    React.useEffect(() => {
        //getRegion();
        //getCountry();
        getPort();
        //getmainport();
        getProduct();
        getBargename();
        getTestParameter();
        getSupplier();
        localStorage.setItem("Supplier", '');
    }, []);
    const getProduct = async () => {

        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `CommonComponent/Fuelgrade`;
        await getRequest(url)
            .then(async (res) => {
                if (res.status == 200) {
                    setProduct(res.data)
                } else {
                    ToastError(res.message);
                }
            })
            .catch((error) => {
                ////console.log(error);
                // ToastError(error.response.data.message);
            });
    }

    const getPort = async () => {

        //let Country = localStorage.getItem("Country");
        //const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/port/${Country}`;
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/port`;
        await getRequest(url)
            .then(async (res) => {
                if (res.status == 200) {
                    setPort(res.data)
                } else {
                    ToastError(res.message);
                }
            })
            .catch((error) => {
                ////console.log(error);
                // ToastError(error.response.data.message);
            });
    }
    const getmainport = async () => {
        let Port = localStorage.getItem("Port");
       
            const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/Mainport/${Port}`;
            //const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/port`;
            await getRequest(url)
                .then(async (res) => {
                    if (res.status == 200) {
                        setMainPort(res.data)
                    } else {
                        ToastError(res.message);
                    }
                })
                .catch((error) => {
                    ////console.log(error);
                    // ToastError(error.response.data.message);
                });
        
    }
    const getCountry = async () => {
        debugger
        let Port = localStorage.getItem("Port");
        // let region = localStorage.getItem("Region");
       
            const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/Country/${Port}`;
            await getRequest(url)
                .then(async (res) => {
                    if (res.status == 200) {
                        setCountry(res.data)
                        console.log(res.data);
                    } else {
                        ToastError(res.message);
                    }
                })
                .catch((error) => {
                    ////console.log(error);
                    // ToastError(error.response.data.message);
                });
        
    }
    const getRegion = async () => {
        // let Country = localStorage.getItem("Country");
        // const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/Region/${Country}`;
        let Port = localStorage.getItem("Port");
       
            const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/Region/${Port}`;
            await getRequest(url)
                .then(async (res) => {
                    if (res.status == 200) {
                        setRegion(res.data)

                    } else {
                        ToastError(res.message);
                    }
                })
                .catch((error) => {
                    ////console.log(error);
                    // ToastError(error.response.data.message);
                });
        
    }

    const getBargename = async (event) => {
        debugger
        const searchStr = event.target.value;
        setValue(searchStr);
        let Supplier = localStorage.getItem("Supplier");
        //let Supplierdata = encodeURIComponent(Supplier) ;
        let Data={};
        Data={
            "SupplierData":Supplier,
            "searchString":searchStr
        }
        if (Supplier == "") {
            ToastError('Please Fill the Supplier to Select Barge Name');
        } else {
            const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/BargeName`;
            await postRequest(url,Data)
                .then(async (res) => {
                    if (res.status == 200) {
                        let result = [];
                        //debugger
                        if (selectedvalue.length > 0) {
                            debugger
                            selectedvalue.forEach((val, i) => {
                                if (i === 0) {
                                    result = res.data.filter((ele) => ele.bargeName != val.bargeName)
                                } else {
                                    result = result.filter((ele) => ele.bargeName != val.bargeName)
                                }
                            })
                            setBargeName(result);
                        }
                        else {
                            setBargeName(res.data)
                        }
                    }
                    else {
                        ToastError(res.message);
                    }
                })
                .catch((error) => {
                    ////console.log(error);
                    // ToastError(error.response.data.message);
                });
        }


    }
    const getTestParameter = async () => {

        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/TestParameter`;
        await getRequest(url)
            .then(async (res) => {
                if (res.status == 200) {
                    setTestParameter(res.data)
                } else {
                    ToastError(res.message);
                }
            })
            .catch((error) => {
                ////console.log(error);
                // ToastError(error.response.data.message);
            });
    }

    const getSupplier = async () => {
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/Supplier`;
        await getRequest(url)
            .then(async (res) => {
                if (res.status == 200) {
                    setSupplier(res.data)
                } else {
                    ToastError(res.message);
                }
            })
            .catch((error) => {
                ////console.log(error);
                // ToastError(error.response.data.message);
            });
    }
    //console.log(formvalues);

    return (
        <div>
            <div>
                <Dialog
                    /*  fullWidth={} */
                    maxWidth="xl"
                    fullWidth
                    maxWidth="sm"
                    open={openpdf}
                //onClose={handleClose}

                >
                    <DialogContent>
                        {pdfURL ? (
                            <iframe
                                src={`${pdfURL}#page=1&toolbar=0`}
                                //src={`${openBunkerAlerts}#page=1&toolbar=0&statusbar=0&scrollbar=1&height=100%`}
                                // frameborder="0"
                                // height={window.screen.height-280}
                                width="100%"
                                //  height={window.screen.height+"px"}
                                // style={{"height":`${window.screen.height-280}px`}}
                                style={{ "min-height": '100%' }, { "height": `${window.screen.height - 90}px` }}
                            ></iframe>
                        ) : (
                            ""
                        )}
                    </DialogContent>
                    <DialogActions>
                        <a href={`${pdfURL}#page=1&toolbar=0`} download={fName} style={{ textDecoration: "none" }}>

                            <Button>Download</Button></a>
                        <Button onClick={() => { handleClose(true) }}> <CancelIcon /></Button>
                    </DialogActions>

                </Dialog>
                {/* <Box component="main" px={3} pb={0} display="flex">
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Box display="dlock">
              <BreadcrumbPage rows={BreadcrumbList} icon={<Help onClick={handleClickOpen}/>}/>
            </Box>
          </Grid>
        </Grid>
            </Box> */}
            </div>
           
            <Box height={1}>
                <Box component="main" mx={3} mt={3} height={1}>
                    <Box className={classes.boxLayout} height={1}>
                        <Box
                            display="dlock"
                            bgcolor="#1a1a31"
                            className={classes.breadcrumbBox}
                        >
                            <BreadcrumbPage rows={BreadcrumbList} />
                        </Box>
                       
                        <Box pt={3} pr={3} pl={3}>
                        <p style={{color:'red'}}>* Note : After the Port selection, the Country, Region and Main Port will appear in the dropdown field.</p>
                            <Grid container spacing={3}>
                                <Grid item xs={4}>

                                    <Stack spacing={3}>
                                        <DatePicker
                                            views={["year"]}
                                            label="Year only"
                                            value={selectedYear}
                                            onChange={(event, newValue) => { handleDateChange(event) }}
                                        //onChange={(item) =>{ ; handleDateChange([item.selection])}}
                                        />



                                    </Stack>
                                </Grid>
                                <Grid item xs={4}>
                                    <Stack spacing={3} >
                                        {
                                            ID !== "" && ID !== undefined ?
                                                <TextField id="standard-basic" label="BA No" value={formvalues.bano} variant="standard" InputProps={{ readOnly: true, }} />
                                                :
                                                <TextField id="standard-basic" label="BA No" value={formvalues.bano} variant="standard" onChange={(newValue) => setFormvalues({ ...formvalues, bano: newValue.target.value })} />
                                        }
                                    </Stack>
                                </Grid>
                                <Grid item xs={4}>
                                    <Stack spacing={3}>
                                        <KeyboardDatePicker
                                            autoOk
                                            //variant="standard"
                                            //variant="inline"
                                            //inputVariant="outlined"
                                            label="Date"
                                            format="DD/MM/yyyy"
                                            value={formvalues.date}
                                            InputAdornmentProps={{ position: "end" }}
                                            onChange={date => setFormvalues({ ...formvalues, date: date._d })}
                                        />
                                    </Stack>
                                </Grid>

                            </Grid>
                            <Grid container spacing={3} pt={2} >
                                <Grid item xs={4} >

                                    <Stack spacing={3}>
                                        <TextField
                                            variant="standard"
                                            id="standard-multiline-static"
                                            label="Subject"
                                            multiline
                                            value={formvalues.subject}
                                            onChange={(newValue) => setFormvalues({ ...formvalues, subject: newValue.target.value })}
                                        />
                                    </Stack>
                                </Grid>
                                <Grid item xs={4}>
                                    <Stack spacing={3}>
                                        <Autocomplete
                                            //multiple
                                            id="size-small-standard-multi"
                                            size="small"
                                            options={port}
                                            getOptionLabel={(option) => option.portName}
                                            value={{ portName: formvalues.portName } || {}}
                                            getOptionSelected={(option, value) => option.portName === value.portName}
                                            onChange={(event, value) => handleChange(event, value, 'port')}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Port"
                                                    variant="standard"
                                                />
                                            )}
                                        />
                                    </Stack>
                                </Grid>
                                <Grid item xs={4}>
                                    <Stack spacing={3}>
                                        <Autocomplete
                                            //multiple
                                            id="size-small-standard-multi"
                                            size="small"
                                            options={mainport}
                                            getOptionLabel={(option) => option.mainport}
                                            value={{ mainport: formvalues.mainport } || {}}
                                            getOptionSelected={(option, value) => option.mainport === value.mainport}
                                            onChange={(event, value) => { if (value) { setFormvalues({ ...formvalues, mainport: value.mainport }) } else { setFormvalues({ ...formvalues, mainport: '' }) } }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Main Port"
                                                    variant="standard"
                                                />
                                            )}
                                        />
                                    </Stack>
                                </Grid>
                                


                            </Grid>
                            <Grid container spacing={3} pt={2}>
                            <Grid item xs={4}>
                                    <Stack spacing={3}>
                                        {console.log("formvalues.countryNm", formvalues.countryNm)}
                                        <Autocomplete
                                            //multiple
                                            id="size-small-standard-multi"
                                            size="small"
                                            options={Country}
                                            getOptionLabel={(option) => option.countryNm}
                                            value={{ countryNm: formvalues.countryNm } || {}}
                                            getOptionSelected={(option, value) => option.countryNm === value.countryNm}

                                            onChange={(event, value) => handleChange(event, value, 'country')}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Country"
                                                    variant="standard"
                                                />
                                            )}
                                        />
                                    </Stack>
                                </Grid>
                                <Grid item xs={4}>
                                    <Stack spacing={3}>

                                        <Autocomplete
                                            //multiple
                                            id="size-small-standard-multi"
                                            size="small"
                                            options={region}
                                            getOptionLabel={(option) => option.geographicalregionds}
                                            value={{ geographicalregionds: formvalues.geographicalregionds } || {}}
                                            getOptionSelected={(option, value) => option.geographicalregionds === value.geographicalregionds}
                                            onChange={(event, value) => handleChange(event, value, 'Region')}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Region"
                                                    variant="standard"
                                                />
                                            )}
                                        />

                                    </Stack>
                                </Grid>
                                <Grid item xs={4}>

                                    <Stack spacing={3}>

                                        <Autocomplete
                                            multiple
                                            id="size-small-standard-multi"
                                            size="small"
                                            options={TestParameter}
                                            getOptionLabel={(option) => option.testParameter}
                                            value={formvalues.testParameter || []}

                                            getOptionSelected={(option, value) => { ; return option.testParameter === value.testParameter }}
                                            onChange={(event, value) => { ; setFormvalues({ ...formvalues, testParameter: value }) }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Test Parameter"
                                                    variant="standard"
                                                />
                                            )}
                                        />
                                    </Stack>
                                </Grid>


                            </Grid>

                            <Grid container spacing={3} pt={2}>
                                <Grid item xs={4}>
                                    <Stack spacing={3}>
                                        <Autocomplete
                                            multiple
                                            id="size-small-standard-multi"
                                            size="small"
                                            options={product}
                                            getOptionLabel={(option) => option.fuelGrade}
                                            value={formvalues.fuelGrade || []}

                                            getOptionSelected={(option, value) => option.fuelGrade === value.fuelGrade}
                                            onChange={(event, value) => setFormvalues({ ...formvalues, fuelGrade: value })}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Product"
                                                    variant="standard"
                                                />
                                            )}
                                        />
                                    </Stack>
                                </Grid>
                                <Grid item xs={4}>
                                    <Stack spacing={3}>
                                        {console.log("formvalues", formvalues)}
                                        <Autocomplete
                                            multiple
                                            id="size-small-standard-multi"
                                            size="small"
                                            options={Supplier}
                                            getOptionLabel={(option) => option.supplier}
                                            value={formvalues.supplier || []}

                                            getOptionSelected={(option, value) => option.supplier === value.supplier}
                                            onChange={(event, value) => handleChange(event, value, 'supplier')}
                                            // onChange={(event, value) => { ; setFormvalues({ ...formvalues, supplier: value }) }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Supplier"
                                                    variant="standard"
                                                />
                                            )}
                                        />

                                    </Stack>
                                </Grid>
                                <Grid item xs={4}>

                                    <Stack spacing={3}>
                                        <Autocomplete
                                            multiple
                                            id="size-small-standard-multi"
                                            size="small"
                                            value={formvalues.bargeName || []}
                                            getOptionSelected={(option, value) => option.bargeName === value.bargeName}
                                            options={BargeName}
                                            getOptionLabel={(option) => option.bargeName}
                                            inputValue={filteredString}
                                            onChange={(event, value) => {
                                                //debugger
                                                console.log("value", value)
                                                setFormvalues({ ...formvalues, bargeName: value })
                                                setSelectedValue(value);
                                                setValue("");
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Barge Name"
                                                    variant="standard"
                                                    onChange={getBargename}
                                                />
                                            )}
                                        />
                                    </Stack>
                                </Grid>

                            </Grid>

                            {/* <Form.Group as={Row} className="justify-content-md-center">
                                <Col sm={4}>
                                    {ID !== "" && ID !== undefined ? <button type="button" className={classes.btn1} onClick={updateform} >Save</button> : <button type="button" className={classes.btn1} onClick={submitform} >Save</button>}
                                    <button type="reset" className={classes.btn2} onClick={clearform}  >Cancel</button>
                                </Col>
                            </Form.Group> */}
                            <Grid container spacing={3} pt={2}>
                                <Grid item xs={4} sx={{ mt: 2 }}>
                                    <Box component="div" className="mb35 padb15" display="flex" py={2} justifyContent="left" >
                                        {ID !== "" && ID !== undefined ? <button type="button" className={classes.btn1} onClick={updateform} >Save</button> : <button type="button" className={classes.btn1} onClick={checkform} >Save</button>}
                                        <button type="reset" className={classes.btn2} onClick={clearform}  >Cancel</button>
                                    </Box>
                                </Grid >
                                <Grid item xs={4} sx={{ mt: 2 }}>
                                    <Form.File id="exampleFormControlFile1"
                                        //style={{ marginRight: '4%', marginTop: '-8%', marginBottom: '2%' }}
                                        onChange={onSubmitProfile}
                                        // ref={imageInputRef} 
                                        accept="application/pdf"
                                    />
                                    <br></br>
                                    {/* <a  onClick={() => { loadPdfFile(filepath, "click") }}>Download PDF</a> */}

                                    {ID !== "" && ID !== undefined ? "Attachement Pdf :" : ""} {ID !== "" && ID !== undefined ? <button className={classes.link} onClick={() => { loadPdfFile(filepath, "click") }}> <EllipsisText text={filepath} length={15} /></button> : ""}
                                </Grid>


                            </Grid>

                        </Box>
                    </Box>
                </Box>
            </Box>
        </div>
    );
}